<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input v-model="symbolId" placeholder="symbolId" clearable />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="tradeSwitch" placeholder="	交易开关">
                <el-option
                  v-for="item in typeList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="show('新增')"
              >新增</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="calc(100vh - 360px)" size="small">
        <el-table-column label="租户" prop="tenantName" />
        <el-table-column label="交易对" prop="symbol" />
        <el-table-column label="盈利率" prop="earningRate" />
        <el-table-column label="行权费率" prop="exerciseRate" />
        <el-table-column label="手续费率" prop="feeRate" />
        <el-table-column label="亏损率" prop="lossRate" />
        <el-table-column label="结算周期" prop="intervalSecond" />
        <el-table-column prop="" label="开关">
          <template slot-scope="scope">
            <span>{{ scope.row.tradeSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </Pagination>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="400px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="开关" prop="">
            <el-switch v-model="formData.tradeSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="盈利率" prop="">
            <el-input
              v-model="formData.earningRate"
              placeholder="盈利率"
              clearable
            />
          </el-form-item>
          <el-form-item label="行权费率" prop="">
            <el-input
              v-model="formData.exerciseRate"
              placeholder="行权费率"
              clearable
            />
          </el-form-item>
          <el-form-item label="手续费率" prop="">
            <el-input
              v-model="formData.feeRate"
              placeholder="手续费率"
              clearable
            />
          </el-form-item>
          <el-form-item label="亏损率" prop="">
            <el-input
              v-model="formData.lossRate"
              placeholder="亏损率"
              clearable
            />
          </el-form-item>
          <el-form-item label="配置id" prop="" required>
            <el-select
              v-model="formData.optionConfigId"
              placeholder="配置id"
              clearable
            >
              <el-option
                v-for="item in optionConfigs"
                :key="item.optionsConfigId"
                :label="item.symbol + '-' + item.intervalSecond"
                :value="item.optionsConfigId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="租户" prop="" required>
            <el-select v-model="formData.tenantId" placeholder="租户" clearable>
              <el-option
                v-for="item in tenantList"
                :key="item.id"
                :label="item.tenantName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";
import { tenantInfo } from "@/common/publicApi";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      symbolId: "",
      tenantId: "",
      tradeSwitch: "",
      tenantList: [],
      typeList: [
        { label: "全部", key: "" },
        { label: "开", key: true },
        { label: "关", key: false },
      ],
      optionConfigs: [],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: {
        tradeSwitch: false,
        earningRate: "",
        exerciseRate: "",
        feeRate: "",
        lossRate: "",
        optionConfigId: "",
        tenantId: "",
      },
    };
  },
  computed: {},
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });

    this.handleSearch();
    api.optionConfigs().then((res) => {
      if (res.code == 0) {
        this.optionConfigs = res.data;
      }
    });
  },
  methods: {
    handleSearch() {
      api
        .getUserList({
          tenantId: this.tenantId,
          symbolId: this.symbolId,
          tradeSwitch: this.tradeSwitch,
          ...this.pagination,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData.tradeSwitch = row.tradeSwitch;
        this.formData.earningRate = row.earningRate;
        this.formData.exerciseRate = row.exerciseRate;
        this.formData.feeRate = row.feeRate;
        this.formData.lossRate = row.lossRate;
        this.formData.optionConfigId = row.optionConfigId;
        this.formData.tenantId = row.tenantId;
        this.formData.id = row.id;
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        tradeSwitch: false,
        earningRate: "",
        exerciseRate: "",
        feeRate: "",
        lossRate: "",
        optionConfigId: "",
        tenantId: "",
      };
    },
    handleSave() {
      if (this.formData.tenantId == "") {
        return this.$message.error("请选择租户");
      }
      api
        .updateOptionConfig({
          ...this.formData,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(this.title + "成功");
            this.close();
            this.handleSearch();
          }
        });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.title {
  margin-bottom: 8px;
  color: red;
  cursor: pointer;
}
/deep/ .el-input-group {
  width: 85%;
}
/deep/ .el-select--medium.w120 {
  width: 120px;
}
</style>
